import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Quiniela } from 'src/app/models/quiniela';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header-simple',
  templateUrl: './header-simple.component.html',
  styleUrls: ['./header-simple.component.css']
})
export class HeaderSimpleComponent implements OnInit {
  quiniela: Quiniela;
  urlQuiniela: string;
  idQuiniela: string;

  constructor(
    private QuinielasService: QuinielasService,
    private rutaActiva: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL de la Quiniela
    if (this.rutaActiva.snapshot.params.url != undefined) {
      this.urlQuiniela = this.rutaActiva.snapshot.params.url;
      this.getQuinielaByURL();
    } else {
      this.idQuiniela = this.rutaActiva.snapshot.params.id;
      this.getQuinielaById();
    }
  }

  getQuinielaByURL(): void {
    var quinielas: Array<Quiniela> = [];


    this.QuinielasService.getQuinielaByURL(this.urlQuiniela).subscribe((items) => {
      // Setting up quinielas
      quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );

      // Es la unica que trae del arreglo
      this.quiniela = quinielas[0]
    });
  }

  getQuinielaById(): void {
    this.QuinielasService.getQuiniela(this.idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
    });
  }

}

